import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import ReasonField from './fields'
import validate from './validator'

const QuestionaireForm = ({ reasons = [] }) => <Field name='reason' reasons={reasons} component={ReasonField} />

QuestionaireForm.propTypes = {
  reasons: PropTypes.array,
}

export default reduxForm({ validate })(QuestionaireForm)
